import { GraphqQlApi } from '@/api/api.js'
import DataSourceBase from '../DataSourceBase'
import vue from 'vue'

let data = {
  loaded: false
}

export default class AbonentCardDataSource extends DataSourceBase {
  constructor(Vue, id) {
    super(Vue, id, data)

    vue.$authEventBus.onSignOut(() => {
      this.$store.commit(`${this.getStoreModuleName()}/setData`, {
        loaded: false,
      })
    })
  }

  // eslint-disable-next-line no-unused-vars
  callAction(actionName, params) {
    if (actionName == 'Save') {
      var data = this.getData().profile
      this.$store.commit('SET_PROCESSING', true)

      GraphqQlApi.callOperation({ operationId: 'saveAbonentProfile' }, data).then(response => {
        response.data.energyAccountMutation.saveUserProfile1
        this.$store.commit('SET_PROCESSING', false)
      })
    }
    return
  }

  /** Перечитка данных и обновление данных в store  */
  refresh() {
    if (this.getData().loading) {
      if (!this.$route.query.unlic && this.getData().currentBa_) {
        this.$router.replace({ query: { unlic: this.getData().currentBa_.value } })
      }
      return
    }
    this.getData().loading = true
    this.$store.commit('SET_PROCESSING', true)

    GraphqQlApi.callOperation({ operationId: 'billingAccounts' }).then(baResponse => {
      // загрузка данных абонента
      GraphqQlApi.callOperation({ operationId: 'abonentProfile' }).then(response => {
        this.$store.commit('SET_PROCESSING', false)

        baResponse = baResponse.data.energyAccountQuery.billingAccounts.data
        var currentBa = this.processBa(baResponse, this.$route.query.unlic)
        var data = { loading: true, billingAccounts: baResponse, currentBa_: currentBa, ...response.data.energyAccountQuery }

        var that = this
        Object.defineProperty(data, 'currentBillingAccount', {
          get() {
            return this.currentBa_
          },
          set(v) {
            this.currentBa_ = that.processBa(baResponse, +v)
            that.$router.replace({ query: { unlic: +v } }).then(() => that.Vue.$root.$emit('unlicchanged'))
          }
        })

        this.$store.commit(`${this.getStoreModuleName()}/setData`, data)
      })
    })

  }
  // обраотка списка счетов пользователя
  processBa(baResponse, current) {
    if (!baResponse.length) {
      return undefined
    }

    baResponse.forEach(el => {
      el.isEntity = !!el.classBillingAcc
      el.isNotEntity = !el.isEntity

      switch (el.classBillingAcc) {
      case 'А':
        el.group = 'Група А'
        break
      case 'Б':
        el.group = 'Група Б'
        break
      default:
        el.group = 'Для дому'
        break
      }
     

    })
    // устанавливаем параметром текущий расчетный счет
    if (!current) {
      this.setUserRole(baResponse[0])
      this.$router.push({ query: {unlic: baResponse[0].value}}).then(() => this.Vue.$root.$emit('unlicchanged'))

      return baResponse[0]
    }
    // находим выбранный расчетный счет, есои не найден - устанавливаем первый из тех, которые пришли
    var ba = baResponse.find(r => r.value == current)
    if (!ba) {
      this.setUserRole(baResponse[0])
      this.$router.push({ query: {unlic: baResponse[0].value}}).then(() => this.Vue.$root.$emit('unlicchanged'))
      

      return baResponse[0]
    }
      
    this.setUserRole(ba)
    return ba    
  }
  // Установка роли по типу счета
  setUserRole(ba) {
    // устанавливаем роль пользователя
    switch (ba.classBillingAcc) {
    case 'А':
      this.$authCore.SetUserRole('entityA')
      break
    case 'Б':
      this.$authCore.SetUserRole('entityB')
      break
    default:
      this.$authCore.SetUserRole('User')
      break
    }
  }
}